import { Injectable } from '@angular/core';
import { ConfigStampeWebService } from './config-stampe-web.service';

export type TipoQuestionario =
  | 'QUESTIONARIO_GENERICO'
  | 'AUTOVALUTAZIONE'
  | 'SURVEY'
  | 'BILANCIO'
  | 'SINTESI'
  | 'INFORMATIVA_AZIENDALE'
  | 'POLICY'
  | 'PIANO'
  | 'BILANCIOGO'
  | 'VALIDAZIONEIRO'
  | 'DOPPIASURVEY'
  | 'REPORT_VSME';

export interface GruppoCfgStampa {
  id: string;
  contesto: string;
  cfgStampa: CfgStampa[];
  idTesto: string;
  headerAndFooterInfo: { [key: string]: any };
}

export interface CfgStampa {
  index: number;
  chiave: string;
  titolo: string;
  descrizione: string;
  contenutoStampa: ContenutoStampa;
  toggle: boolean;
  disabled: boolean;
}

interface ContenutoStampa {
  tipo: string;
  content?: DocumentoDiStampa;
  attach?: string;
  originalFileName?: string;
  txtContent?: string;
}

interface DocumentoDiStampa {
  idTesto: string;
  datiDocumento: DatiDocumento;
  parametri: any;
  escludiParametriStandard: boolean;
  subreportsName: string[];
}

interface DatiDocumento {
  descrizione: string;
  domanda: string;
  motivazione: string;
  nome_breve: string;
}

@Injectable({
  providedIn: 'root',
})
export class ConfigStampeService {
  constructor(private readonly configStampeWebService: ConfigStampeWebService) {}

  public getLineeGuida(contesto: TipoQuestionario) {
    return this.configStampeWebService.getLineeGuida(contesto);
  }

  public salvaLineaGuida(config: CfgStampa, contesto: TipoQuestionario) {
    return this.configStampeWebService.salvaLineaGuida(config, contesto);
  }

  public salvaTemplateMail(
    mailNotifica: string,
    mailInvio: string,
    landingPage: string,
    contesto: TipoQuestionario,
  ) {
    return this.configStampeWebService.salvaTempalteMail(
      mailNotifica,
      mailInvio,
      landingPage,
      contesto,
    );
  }
  public getSignedLinkFile(fileName: string) {
    return this.configStampeWebService.getSignedLinkFile(fileName);
  }
}
